import {ChangeDetectionStrategy, Component, ElementRef, ViewChild, ViewEncapsulation} from "@angular/core";

declare let $:any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'catalogs',
  styles: [ require('./catalogs.component.css') ],
  template: require('./catalogs.component.html')
})
export class CatalogsComponent {
  currentCatalog;

  // catalogs = [
  //   {
  //     url: "/assets/images/catalogs/K2017.pdf",
  //     title: "Иновации 2017",
  //     name: "Kennametal иновации - Каталог 2017 (36 MB)",
  //     imageUrl: "/assets/images/catalogs/2017.jpg"
  //   },
  //   {
  //     url: "/assets/images/catalogs/K2016.pdf",
  //     title: "Иновации 2016",
  //     name: "Kennametal иновации - Каталог 2016 (16 MB)",
  //     imageUrl: "/assets/images/catalogs/2016.jpg"
  //   },
  //   {
  //     url: "/assets/images/catalogs/K2015.pdf",
  //     title: "Иновации 2015",
  //     name: "Kennametal иновации - Каталог 2015 (5 MB)",
  //     imageUrl: "/assets/images/catalogs/2015.jpg"
  //   }
  // ];


  catalogs = [
    {
      url: "https://cdn.cdev.bg/arton/Tool_Management_Solutions.pdf",
      name: "Tool Management Solutions",
      imageUrl: "/assets/images/catalogs/Tool_Management_Solutions.jpg",
      langImg: "/assets/images/catalogs/Kyocera_logo_small.svg"
    },
    {
      url: "https://cdn.cdev.bg/arton/Tool_Maintenance_RENEW.pdf",
      name: "Tool Maintenance RENEW",
      imageUrl: "/assets/images/catalogs/Tool_Maintenance.jpg",
      langImg: "/assets/images/catalogs/Kyocera_logo_small.svg"
    },
    {
      url: "https://cdn.cdev.bg/arton/2023-2024_General_Catalog.pdf",
      name: "Kyocera 2023-2024 General Catalog",
      imageUrl: "/assets/images/catalogs/2023-2024_General_Catalog.jpg",
      langImg: "/assets/images/catalogs/Kyocera_logo_small.svg"
    },
    {
      url: "https://cdn.cdev.bg/arton/DRA_MagicDrill_EN_-_TZE00215.pdf",
      name: "MagicDrill DRA",
      imageUrl: "/assets/images/catalogs/DRA_MagicDrill_EN_-_TZE00215.png",
      langImg: "/assets/images/catalogs/Kyocera_logo_small.svg"
    },
    {
      url: "https://cdn.cdev.bg/arton/MB45_EN_-_TZE00231.pdf",
      name: "MB45",
      imageUrl: "/assets/images/catalogs/MB45_EN_-_TZE00231.png",
      langImg: "/assets/images/catalogs/Kyocera_logo_small.svg"
    },
    {
      url: "https://cdn.cdev.bg/arton/Solid_Tools_Catalog_-_TZE00213.pdf",
      name: "KYOCERA Solid Tools",
      imageUrl: "/assets/images/catalogs/Solid_Tools_Catalog_-_TZE00213.png",
      langImg: "/assets/images/catalogs/Kyocera_logo_small.svg"
    },
    {
      url: "https://cdn.cdev.bg/arton/MA90_-_TZE00223.pdf",
      name: "MA90",
      imageUrl: "/assets/images/catalogs/MA90_-_TZE00223.png",
      langImg: "/assets/images/catalogs/Kyocera_logo_small.svg"
    },
    {
      url: "https://cdn.cdev.bg/arton/Korloy_Cutting_Tools.pdf",
      name: "Korloy Cutting Tools 2022-2023 (Metric)",
      imageUrl: "/assets/images/catalogs/Korloy_Cutting_Tools.jpg",
      langImg: "/assets/images/catalogs/Korloy_logo_small.svg"
    },
    {
      url: "https://cdn.cdev.bg/arton/Korloy_2018_New_Products_EM.pdf",
      name: "Korloy's New And Best-Selling Products",
      imageUrl: "/assets/images/catalogs/Korloy_2018_New_Products_EM.png",
      langImg: "/assets/images/catalogs/Korloy_logo_small.svg"
    },
  ];

  @ViewChild("catalogModalDiv") catalogModalDiv: ElementRef;

  openModal(catalog){
    this.currentCatalog = catalog;
    $(this.catalogModalDiv.nativeElement).modal('show');
  }

  closeModal(){
    this.currentCatalog = null;
    $(this.catalogModalDiv.nativeElement).modal('hide');
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+catalogs/catalogs.component.ts